import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SetCard from "../components/sets/SetCard";

const axios = require("axios").default;

function Home() {
  const [cardData, changeCardData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .post("https://application-flashcards.herokuapp.com/api/sets", {
        token,
      })
      .then(function (response) {
        const sort = response.data.sort((a, b) => {
          return a.setName.localeCompare(b.setName);
        });
        console.log(sort);
        changeCardData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <div>
      <div className="bg-zinc-800 text-slate-200 py-2 px-32 flex justify-end xsm:justify-center xsm:flex-col md:px-12">
        <button
          className="text-white bg-green-400 border-grey-100 rounded p-2 hover:bg-green-500 xsm:w-full"
          onClick={() => {
            navigate("/dashboard/addset");
          }}
        >
          Add Set
        </button>
      </div>
      {cardData.length === 0 ? (
        <div className="rounded-lg border-solid border border-slate-200 my-2 w-6/12 shadow-md p-2 mx-auto mt-16 py-10 px-10 xsm:mx-auto xsm:my-5 xsm:w-10/12 md:w-6/12">
          <p>
            You currently have no sets of flashcards. Add a set to view them
            here.
          </p>
        </div>
      ) : (
        <div className="grid gap-4 grid-cols-4 auto-rows-max px-32 pt-4 px-8 xsm:flex xsm:flex-col sm:grid-cols-2 lg:grid-cols-3">
          {cardData.map((e, i) => {
            return (
              <SetCard
                key={e.id}
                flashcards={<></>}
                setName={e.setName}
                highScore={e.highScore}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Home;
